import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@treasuryspring/spring-ui';
import classNames from 'classnames';

import useWindowSize from '@/hooks/useWindowSize';
import { formatMoney } from '@/utils/helper-functions';

interface ValuationTableProps {
  maturityValue: number;
  maturityIncome: number;
  annualizedIncome: number;
  currencySymbol: string;
  className?: string;
}

function ValuationTable({
  maturityValue,
  maturityIncome,
  annualizedIncome,
  currencySymbol,
  className,
}: ValuationTableProps) {
  const { width } = useWindowSize();

  if (width < 768) {
    return (
      <div className="flex flex-col">
        <Table className={classNames('border', className)}>
          <TableHeader>
            <TableRow>
              <TableHead className="p-s text-subtitle2 border">
                Maturity value
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell className="p-s border">
                {currencySymbol} {formatMoney(maturityValue)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Table className={classNames('border', className)}>
          <TableHeader>
            <TableRow>
              <TableHead className="p-s text-subtitle2 border">
                Maturity income
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell className="p-s border">
                {currencySymbol} {formatMoney(maturityIncome)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Table className={classNames('border', className)}>
          <TableHeader>
            <TableRow>
              <TableHead className="p-s text-subtitle2 border">
                Annualized income
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell className="p-s border">
                {currencySymbol} {formatMoney(annualizedIncome)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    );
  }

  return (
    <Table className={classNames('border', className)}>
      <TableHeader>
        <TableRow>
          <TableHead className="p-s text-subtitle2 border">
            Maturity value
          </TableHead>
          <TableHead className="p-s text-subtitle2 border">
            Maturity income
          </TableHead>
          <TableHead className="p-s text-subtitle2 border">
            Annualized income
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell className="p-s border">
            {currencySymbol} {formatMoney(maturityValue)}
          </TableCell>
          <TableCell className="p-s border">
            {currencySymbol} {formatMoney(maturityIncome)}
          </TableCell>
          <TableCell className="p-s border">
            {currencySymbol} {formatMoney(annualizedIncome)}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

export default ValuationTable;
